import { RecordType } from '@petconsole/pure-base';
import { vanBuilderApiEntity } from '@petconsole/pure-fe-api';
import { VanBuilderRecord } from '@petconsole/pure-shared';
import { sliceHookTypes } from '../../../helpers';
import {
  BaseSliceOptions,
  BaseSliceTab,
  CitySearchHooks,
  OurEntityHooks,
  RatingHooks,
  RequiredCrudSliverHooks,
  RequiredSliverHooks,
  TabValueHooks,
} from '../../../types';
import BaseEntitySlice from '../../base/BaseEntitySlice';

type ApiEntityRecord = VanBuilderRecord;

const apiEntity = vanBuilderApiEntity;
const { name: sliceName, plural } = apiEntity;
const vanBuilder = sliceName;
const vanBuilders = plural;
const vanBuilderAdmin = `${sliceName}Admin`;

const Tab = { vanBuilderAdmin, vanBuilder, vanBuilders } as const;
type Tabs = { [key in keyof typeof Tab]: BaseSliceTab };
type TabHooks = { [key in keyof typeof Tab]: TabValueHooks };
const tabs: Tabs = {
  vanBuilderAdmin: { default: '' },
  vanBuilder: { default: '' },
  vanBuilders: { default: 'Newest' },
};

const options: BaseSliceOptions<ApiEntityRecord> = {
  ...apiEntity,
  hasCitySliver: true,
  hasNewestSliver: true,
  hasCitySearch: true,
  hasDefaultProperties: true,
  hasRating: true,
  tabs,
};
const { hooks, reducer } = new BaseEntitySlice<ApiEntityRecord>({ options });
const { crudHooks, sliverHooks, propertyHooks, citySearchHooks, ratingHooks, tabHooks } = sliceHookTypes;

export interface OurVanBuilderHooks<T extends RecordType = ApiEntityRecord> extends OurEntityHooks<T> {
  vanBuilderHooks: RequiredCrudSliverHooks;
  cityVanBuilderHooks: RequiredSliverHooks;
  newestVanBuilderHooks: RequiredSliverHooks;
  propertyHooks: RecordType;
  citySearchHooks: CitySearchHooks;
  ratingHooks: RatingHooks;
  tabHooks: TabHooks;
}

export const ourVanBuilderHooks: OurVanBuilderHooks = {
  entity: apiEntity,
  vanBuilderHooks: crudHooks(apiEntity, hooks) as RequiredCrudSliverHooks,
  cityVanBuilderHooks: sliverHooks(apiEntity, 'City', hooks) as RequiredSliverHooks,
  newestVanBuilderHooks: sliverHooks(apiEntity, 'Newest', hooks) as RequiredSliverHooks,
  citySearchHooks: citySearchHooks(apiEntity, hooks),
  propertyHooks: propertyHooks(apiEntity, hooks),
  ratingHooks: ratingHooks(apiEntity, hooks),
  tabHooks: <TabHooks>tabHooks(Object.keys(Tab), hooks),
};

export default reducer;
